import { render, staticRenderFns } from "./SolicitarDinero.vue?vue&type=template&id=2f2a8793&"
import script from "./SolicitarDinero.vue?vue&type=script&lang=js&"
export * from "./SolicitarDinero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports